import axios from "../../axios";
import FetchError from "./FetchError";

class ApiService {
  get axios() {
    return axios;
  }

  throwFetchError(err) {
    throw new FetchError(err);
  }
}

export default ApiService;
